import type { Product } from "@/models/product";

/**
 * Picks the CMS image path for a fabric+frame configuration. Sun protection
 * has fabric+frame combination images that depict both colours together —
 * prefer those, then the fabric colour's own image, then the product's base
 * image.
 *
 * Returns the raw CMS path (relative or absolute); callers wrap with
 * `cmsUrl` from `@kozien/shared` to attach the environment-specific base.
 */
export function resolveDecorationImageUrl(
    product: Product | null | undefined,
    fabricColorId: string | null | undefined,
    frameColorId: string | null | undefined,
): string | null {
    if (!product) return null;

    const fabric = fabricColorId
        ? product.fabricColors.find((c) => c.id === fabricColorId)
        : undefined;
    const frame = frameColorId
        ? product.frameColors.find((f) => f.id === frameColorId)
        : undefined;

    if (product.hasFrameColor && fabric?.name && frame?.name) {
        const combo = product.colorCombinations.find(
            (cc) =>
                !cc.irrelevant &&
                cc.fabricColorName === fabric.name &&
                cc.frameColorName === frame.name,
        );
        if (combo?.image?.url) return combo.image.url;
    }
    if (fabric?.image?.url) return fabric.image.url;
    if (product.image?.url) return product.image.url;
    return null;
}
